import React, { useState, useEffect } from "react";
import style from "./Info.module.css";
import infoWindow from "../../assets/images/stuff/infoWindow.png";
import closeInfo from "../../assets/images/stuff/closeInfo.png";
import allContent from "../../allContent";
import watchVideos from "../../assets/images/slides/watchVideos.png";
import claimStickers from "../../assets/images/slides/claimStickers.png";
import downloadStickers from "../../assets/images/slides/downloadStickers.png";

const Info = ({ setShowInfo }) => {
  const [opacity, setOpacity] = useState(0);
  const [infoPop, setInfoPop] = useState(0);

  useEffect(() => {
    setTimeout(() => {
      setOpacity(1);
    }, 100);
  }, []);

  const handleClose = () => {
    setOpacity(0);
    setTimeout(() => {
      setShowInfo(false);
    }, 500);
  };
  return (
    <div className="infoPopUp scaleInfoPopUp">
      // {/* <div className={style.info} style={{ opacity: opacity }}> */}
      {/* <img src={infoWindow} alt="infoWindow" />
      <img
        src={closeInfo}
        alt="closeInfo"
        className={style.close}
        onPointerDown={handleClose}
      /> */}
      <div className="infoPopUpWrap">
        <div className="iconAndText">
          <img src={watchVideos} alt="watchVideos" />
          <p>
            {allContent.infoWindow.watch.split("\n").map((line, index) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </p>
        </div>
        <div className="iconAndText">
          <img src={claimStickers} alt="claimStickers" />
          <p>
            {allContent.infoWindow.claim.split("\n").map((line, index) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </p>
        </div>
        <div className="iconAndText">
          <img src={downloadStickers} alt="downloadStickers" />
          <p>{allContent.infoWindow.download}</p>
        </div>
        <img
          onClick={() => {
            handleClose();
          }}
          className="closeInfo closeInfo2"
          src={closeInfo}
          alt="closeInfo"
        />
      </div>
      {/* </div> */}
    </div>
  );
};

export default Info;
